import { render, staticRenderFns } from "./FunderSettingLayout.vue?vue&type=template&id=23de778c"
import script from "./FunderSettingLayout.vue?vue&type=script&lang=js"
export * from "./FunderSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23de778c')) {
      api.createRecord('23de778c', component.options)
    } else {
      api.reload('23de778c', component.options)
    }
    module.hot.accept("./FunderSettingLayout.vue?vue&type=template&id=23de778c", function () {
      api.rerender('23de778c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/layout/FunderSettingLayout.vue"
export default component.exports